import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5db9d774"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex justify-between mt-4" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "icon-spin"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextField = _resolveComponent("TextField")!
  const _component_InputFile = _resolveComponent("InputFile")!
  const _component_Alert = _resolveComponent("Alert")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_ModalAlert = _resolveComponent("ModalAlert")!
  const _component_ModalForm = _resolveComponent("ModalForm")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Modal, {
      title: "Agregar un block",
      visible: _ctx.showModal,
      "onUpdate:visible": _cache[14] || (_cache[14] = (e) => _ctx.showModal = e),
      onClose: _ctx.cancelModal
    }, {
      default: _withCtx(() => [
        _createVNode(_component_TextField, {
          label: "Nombre del edificio*",
          model: _ctx.block.name,
          "onUpdate:model": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.block.name) = $event)),
          type: "text",
          name: "nombre"
        }, null, 8, ["model"]),
        _createVNode(_component_TextField, {
          label: "Rut de la compañía (sin puntos) *",
          model: _ctx.block.rut,
          "onUpdate:model": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.block.rut) = $event)),
          type: "text",
          name: "rut"
        }, null, 8, ["model"]),
        _createVNode(_component_TextField, {
          label: "Dirección *",
          model: _ctx.block.address,
          "onUpdate:model": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.block.address) = $event)),
          type: "text",
          name: "dirección"
        }, null, 8, ["model"]),
        _createVNode(_component_TextField, {
          label: "Año de construcción",
          model: _ctx.block.constructionYear,
          "onUpdate:model": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.block.constructionYear) = $event)),
          type: "number",
          name: "año construcción"
        }, null, 8, ["model"]),
        _createVNode(_component_TextField, {
          label: "Compañía de construcción",
          model: _ctx.block.constructionCompany,
          "onUpdate:model": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.block.constructionCompany) = $event)),
          type: "text",
          name: "Compañia de construcción"
        }, null, 8, ["model"]),
        _createVNode(_component_TextField, {
          label: "Total de locales comerciales",
          model: _ctx.block.totalCommercialPremises,
          "onUpdate:model": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.block.totalCommercialPremises) = $event)),
          type: "number",
          name: "Total de locales comerciales"
        }, null, 8, ["model"]),
        _createVNode(_component_TextField, {
          label: "Total de pisos *",
          model: _ctx.block.totalFloors,
          "onUpdate:model": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.block.totalFloors) = $event)),
          type: "number",
          name: "Total de pisos"
        }, null, 8, ["model"]),
        _createVNode(_component_TextField, {
          label: "Total de estacionamientos",
          model: _ctx.block.totalParkingSpots,
          "onUpdate:model": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.block.totalParkingSpots) = $event)),
          type: "number",
          name: "Total de estacionamientos"
        }, null, 8, ["model"]),
        _createVNode(_component_TextField, {
          label: "Total de niveles subterraneos",
          model: _ctx.block.totalUndegroundLevels,
          "onUpdate:model": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.block.totalUndegroundLevels) = $event)),
          type: "number",
          name: "Total de piso"
        }, null, 8, ["model"]),
        _createVNode(_component_TextField, {
          label: "Total de unidades *",
          model: _ctx.block.totalUnits,
          "onUpdate:model": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.block.totalUnits) = $event)),
          type: "number",
          name: "Total de unidades (departamentos, oficinas, locales comerciales)"
        }, null, 8, ["model"]),
        _createVNode(_component_TextField, {
          label: "Total de estacionamientos de visitantes",
          model: _ctx.block.totalVisitorParkingSpots,
          "onUpdate:model": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.block.totalVisitorParkingSpots) = $event)),
          type: "number",
          name: "Total de estacionamientos de visitantes"
        }, null, 8, ["model"]),
        _createVNode(_component_TextField, {
          label: "Total de bodegas",
          model: _ctx.block.totalWarehouseSpaces,
          "onUpdate:model": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.block.totalWarehouseSpaces) = $event)),
          type: "number",
          name: "Total de bodegas"
        }, null, 8, ["model"]),
        _createVNode(_component_InputFile, {
          label: "imagen",
          onUploadFile: _ctx.handleFile
        }, null, 8, ["onUploadFile"])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", null, [
          (_ctx.showAlert)
            ? (_openBlock(), _createBlock(_component_Alert, {
                key: 0,
                type: _ctx.type,
                message: _ctx.message
              }, null, 8, ["type", "message"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("button", {
            class: "px-4 py-2 mr-2 rounded-md bg-gray-300 hover:bg-gray-400 focus:bg-gray-400",
            onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.cancelModal && _ctx.cancelModal(...args)))
          }, "Cancelar"),
          _createElementVNode("button", {
            class: "px-4 py-2 rounded-md bg-primary text-white hover:bg-green-600 focus:bg-green-600",
            onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.saveBlock && _ctx.saveBlock(...args))),
            disabled: _ctx.loading
          }, [
            (!_ctx.loading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Agregar"))
              : (_openBlock(), _createElementBlock("span", _hoisted_4, _hoisted_6))
          ], 8, _hoisted_2)
        ])
      ]),
      _: 1
    }, 8, ["visible", "onClose"]),
    (_ctx.success)
      ? (_openBlock(), _createBlock(_component_ModalAlert, {
          key: 0,
          visible: _ctx.success,
          option: true,
          itsCancel: _ctx.itsCancel,
          onAccept: _ctx.handleAcceptSuccess,
          onCancelAlert: _ctx.handleCancelSuccess
        }, null, 8, ["visible", "itsCancel", "onAccept", "onCancelAlert"]))
      : _createCommentVNode("", true),
    (_ctx.showQuestionary)
      ? (_openBlock(), _createBlock(_component_ModalForm, {
          key: 1,
          communityId: _ctx.communityId,
          blockId: _ctx.blockId,
          visible: _ctx.showQuestionary,
          onCloseModal: _ctx.closeQuestionary
        }, null, 8, ["communityId", "blockId", "visible", "onCloseModal"]))
      : _createCommentVNode("", true)
  ]))
}